import React from 'react';
import clsx from 'clsx';
import type { WatermarkThumbShape } from 'fym-shared/src/music24/watermarkUpsell';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the upsell; each part uses its own slice of it */
import styles from '../WatermarkUpsell.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface WatermarkThumbTileProps {
  /** An absolute picture address; null draws an empty tile. */
  url: string | null;
  shape: WatermarkThumbShape;
  /** The pink ring of the "now" tile (design a1, a2 `.tu-wm.mark`). */
  marked?: boolean;
  /** The "on a plan" tile of a1: the foot with the mark is cut off. */
  clean?: boolean;
  className?: string;
}

const SHAPE_CLASS: Record<WatermarkThumbShape, string | undefined> = {
  story: undefined,
  square: styles.tileSquare,
  portrait: styles.tilePortrait,
  wide: styles.tileWide,
};

/**
 * One file thumbnail (design: trial-upsell `.tu-tile`). The picture is the real file (the poster
 * of a video), so the Music24 mark on it is the real mark.
 */
const WatermarkThumbTileComponent: React.FC<WatermarkThumbTileProps> = (props) => {
  const { url, shape, marked = false, clean = false, className } = props;
  return (
    <div
      className={clsx(styles.tile, SHAPE_CLASS[shape], marked && styles.marked, clean && styles.tileClean, className)}
    >
      {url !== null && <img src={url} alt="" loading="lazy" />}
    </div>
  );
};

export const WatermarkThumbTile = TypedMemo(WatermarkThumbTileComponent);
